import { ChangeDetectorRef, Component, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { System } from '@app/core/resources/system';
import { Transaction } from '@app/transactions/transaction';
import { TransactionsService } from '@app/transactions/services/transactions.service';
import { ReferralsService } from '@app/core/services/referrals.service';
import { AccountServiceProvider } from '@app/core/account-service-provider/account-service-provider';
import { SystemsUpdatedService } from '@app/transactions/services/systems-updated.service';
import { Subscription, debounceTime, filter } from 'rxjs';
import { CustomErrorHandlerService } from '@app/exceptions/custom-error-handler.service';
import { ErrorFormRenderService } from '@app/exceptions/services/error-form-render.service';
import { TransactionFormService } from './transaction-form.service';
import { SourceService } from '../../../core/services/source.service';
import { MetasService } from '@app/core/services/metas.service';
import { AnalyticService } from '@app/core/services/analytic.service';
import { UrlUpdateService } from '@app/core/services/url-update.service';
import { Router } from '@angular/router';
import { MetaTransactionsHelper } from '@app/transactions/helper/meta-transactions.helper';
import { FeeProvider } from '../fee-message/fee-provider';
import { MessageAlertQuotationHelper } from '@app/transactions/helper/message-alert-quotation.helper';
import { TransactionObserverService } from '@app/transactions/services/transaction-observer.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ViaTransactinoEnum } from '@app/core/enums/metas.enum';
import { NetworkSystemService } from '@app/core/services/network-system.service';
import { NetworkMessageHelper } from '@app/core/helpers/network-message-helper';
import { NetworkFilterHelper } from '@app/core/helpers/address-verification.helper';
import { Network } from '@app/core/resources/networks';
import NetworkHelper from '@app/transactions/network-helper';
import { BlockchainsEnum } from '@app/core/enums/blockchains.enum';

export const checkSpecialAddressBySystem: (pagoMovilAdress: string, systemId: string) => boolean = (
    pagoMovilAdress: string,
    systemId: string
): boolean => {
    let addressValidatorRegexBySystem: { [key: string]: RegExp } = {
        banco_bol: /^([a-zA-Z]{3})\+([0-9]{10,22})$/,
        pago_movil: /^(0[0-9]{3})\+(04[0-9]{9})$/
    };
    if (addressValidatorRegexBySystem[systemId].test(pagoMovilAdress)) {
        return true;
    }

    return false;
};

interface ISystemRequirement {
    system: string;
    requirements: string;
    way: 1 | 2;
}

@Component({
    selector: 'app-transaction-form',
    templateUrl: './transaction-form.component.html',
    styleUrls: ['./transaction-form.component.scss']
})
export class TransactionFormComponent implements OnInit, OnDestroy {
    public system1: System | null | undefined = new System();
    public system2: System | null | undefined = new System();
    public pagoMovilAdress: string = '';
    public cryptoAdress: string = '';
    public checkInputEmail: boolean = false;
    public transaction: Transaction = new Transaction();
    public checkRequirements: boolean = false;
    public showCheckRequirements: boolean = false;
    public showCheckUsdt: boolean = false;
    public userEmail: string = '';
    public domainEmail: Array<String> = [''];
    public checkAccountPagoMovil: boolean = false;
    public listDomain: Array<String> = ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com'];
    public fee: number = 0;
    public finalFee: number = 0;
    private feeProvider: FeeProvider = new FeeProvider();
    public networkTitle: string | null = null;
    public filteredNetworks: Array<{ network: Network; disabled: boolean }> = [];
    public networks: Array<any> = [];
    public selectedNetworkId: string = '';
    public isMatSelectDisabled: boolean = false;
    public firstNetworkEnabled: boolean = false;
    public systemRequirements: Array<ISystemRequirement> = [
        // {
        //     system: 'skrill',
        //     requirements: 'step_one_alert_string_skrill',
        //     way: 1
        // },
        // {
        //     system: 'banco_ar_usd',
        //     requirements:
        //         'Mi cuenta bancaria en USD es apta para recibir más de una transferencia mes calendario y tengo lo necesario' +
        //         ' para justificar que provienen de una actividad legítima, de acuerdo a COM 'A' 7072 del BCRA',
        //     way: 2
        // },
        {
            system: 'payoneer',
            requirements: 'step_one_alert_string_payoneer',
            way: 2
        },
        // {
        //     system: 'dai',
        //     requirements: 'step_one_alert_string_dai',
        //     way: 2
        // },
        {
            system: 'nequi',
            requirements: 'step_one_alert_string_nequi',
            way: 1
        },
        {
            system: 'uala2',
            requirements:
                'Los datos ingresados corresponden al <a class="rs-link" href="/assets/images/obtener-alias-uala.png" target="_blank">CVU o alias para transferecias de mi Ualá</a>.',
            way: 2
        }
    ];
    public originsPalpal: Array<string> = ['España', 'México', 'Otro país'];
    public metaTransactionsHelper!: MetaTransactionsHelper;
    public systemsSubscription: Subscription = new Subscription();
    public was_saved: boolean = false;
    public accountService: AccountServiceProvider = new AccountServiceProvider();
    public transaction_form: FormGroup;
    public networkHelper: NetworkHelper;

    public constructor(
        public transactionsService: TransactionsService,
        public referralsService: ReferralsService,
        public transactionFormService: TransactionFormService,
        public changeDetectorRef: ChangeDetectorRef,
        public error: CustomErrorHandlerService,
        private sourceService: SourceService,
        private systemsUpdatedService: SystemsUpdatedService,
        private builder: FormBuilder,
        private errorFormService: ErrorFormRenderService,
        private metasService: MetasService,
        private urlUpdateService: UrlUpdateService,
        private router: Router,
        public messageAlertQuotationHelper: MessageAlertQuotationHelper,
        private analyticService: AnalyticService,
        public networkSystemService: NetworkSystemService,
        private networkFilterHelper: NetworkFilterHelper,
        @Optional() public dialogRef: MatDialogRef<TransactionFormComponent>
    ) {
        this.metasService.register();
        this.transaction_form = this.builder.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required]],
            whatsapp: ['', [Validators.required]],
            address1: [''],
            address2: [''],
            account_network2: [''],
            origin: [''],
            check_requirements: ['']
        });
        this.observerEmail();
        this.observerNetworkCrypto();
        this.networkHelper = new NetworkHelper(this.transaction);
    }

    public ngOnInit(): void {
        this.transaction = this.transactionFormService.getTransaction();
        this.metaTransactionsHelper = new MetaTransactionsHelper(this.transaction);
        this.messageAlertQuotationHelper.transaction = this.transaction;
        this.setSystems();
        this.listenSystemChanges();
        this.changedTransaction();
        this.waitCheck();
        this.transaction_form.controls.address2.valueChanges.pipe(debounceTime(100)).subscribe((address) => {
            this.filterNetworks(address);
            this.networkSelect(address);
        });
        this.changeDetectorRef.detectChanges();
    }

    private setFeeToCheckPaypal(): void {
        this.feeProvider.setTransaction(this.transaction);
        this.fee = this.feeProvider.getBySystem('send', 2).getFee();
        this.finalFee = this.feeProvider.getBySystem('send', 2).getFinalFee(this.transaction.attributes.amount2);
        if (!this.fee) {
            return;
        }
        let objExists: boolean = this.systemRequirements.some((obj) => obj.system === 'palpal');

        if (!objExists) {
            this.systemRequirements.push({
                system: 'palpal',
                requirements: 'step_one_alert_string_palpal',
                way: 2
            });
        }
    }

    public ngOnDestroy(): void {
        this.systemsSubscription.unsubscribe();
    }

    private waitCheck(): void {
        this.transactionFormService.transactionUpdated$.subscribe((status) => {
            if (status.title === 'restart_check') {
                this.checkRequirements = false;
                this.setChecks();
            }
        });
    }

    private setChecks(): void {
        this.setFeeToCheckPaypal();
        this.systemRequirements.forEach((systemRequirement): void => {
            if (this.transaction && systemRequirement.system === this.transaction.relationships['system' + systemRequirement.way].data.id) {
                this.setValidators(Validators.requiredTrue);
                this.showCheckRequirements = true;
            } else {
                this.setValidators([]);
            }
        });
    }

    private setValidators(validator: any): void {
        this.transaction_form.controls.check_requirements.setValidators(validator);
        this.transaction_form.controls.check_requirements.updateValueAndValidity();
        this.transaction_form.controls.check_requirements.setValue(false);
    }

    public listenSystemChanges(): void {
        this.systemsSubscription = this.systemsUpdatedService.systemsUpdated$.subscribe((): void => {
            this.setSystems();
        });
    }

    private changedTransaction(): void {
        new TransactionObserverService(this.transaction)
            .observeTransaction()
            .pipe(
                filter((change): boolean => ['amount1', 'amount2', 'system1', 'system2'].includes(change.attribute_name)),
                debounceTime(100)
            )
            .subscribe((): void => {
                this.fee = this.feeProvider.getBySystem('send', 2).getFee();
                this.finalFee = this.feeProvider.getBySystem('send', 2).getFinalFee(this.transaction.attributes.amount2);
                this.changeDetectorRef.markForCheck();
            });
    }

    private setSystems(): void {
        this.system1 = this.transaction.relationships.system1.data;
        this.system2 = this.transaction.relationships.system2.data;
        this.specialsId(this.system2);
        this.verifyRequirementsAndSetValidators();
        this.filteredNetworks = this.networkFilterHelper.disableNetworks('', this.system2 ?? new System());
        this.networkSelect('');
    }

    public observerNetworkCrypto(): void {
        this.transaction_form.controls.address2.valueChanges.subscribe((value) => {
            this.showCheckUsdt = false;

            if (/^0x[a-fA-F0-9]{40}$/.test(value) && this.system2?.id === 'usdt') {
                this.showCheckUsdt = true;
            }
        });
    }

    public observerEmail(): void {
        this.transaction_form.controls.email.valueChanges.subscribe((value) => {
            if (value.includes('@')) {
                this.checkInputEmail = true;
            } else {
                this.checkInputEmail = false;
            }
            this.userEmail = value.split('@')[0] + '';
            this.domainEmail = this.filterDomainEmail(value.split('@')[1] + '');
        });
    }

    private filterDomainEmail(domain: string): Array<String> {
        return this.listDomain.filter((v) => v.match(domain));
    }

    private verifyRequirementsAndSetValidators(): void {
        if (!this.system1 || !this.system2) {
            return;
        }
        this.setChecks();
        if (this.system1.attributes.account_required_send) {
            this.setValidatorsAndErrors(this.transaction_form.controls.address1, this.system1);
        } else {
            this.transaction_form.controls.address1.setValue('');
            this.transaction_form.controls.address1.setValidators([]);
            this.transaction_form.controls.address1.updateValueAndValidity();
        }
        let specialsId: Array<string> = ['banco_bol', 'moneygram', 'pago_movil', 'vcc'];
        if (specialsId.includes(this.system2.id)) {
            this.transaction_form.controls.address2.setValidators([]);
            this.transaction_form.controls.address2.updateValueAndValidity();

            return;
        } else {
            this.setValidatorsAndErrors(this.transaction_form.controls.address2, this.system2);
        }
        this.errorFormService.setForm(this.transaction_form);
    }

    public closeForm(): void {
        this.dialogRef.close(false);
    }

    private callMetaTransactionsHelper(): void {
        this.metaTransactionsHelper.addMetasToTransaction();
        this.metaTransactionsHelper.addPublicObservationsToTransaction(
            this.transaction_form.value.origin ? 'País de la cuenta: ' + this.transaction_form.value.origin : ''
        );
        this.metaTransactionsHelper.addViaMetasToTransaction(ViaTransactinoEnum.LANDING);
    }

    public save(): void {
        if (this.transaction_form.invalid) {
            return;
        }

        this.fillTransaction();
        let transaction: Transaction = new Transaction();
        transaction.attributes = this.transaction.attributes;
        transaction.relationships = this.transaction.relationships;
        transaction.save({ include: ['metas'] }).subscribe(
            (response: any): void => {
                if (this.system2 && this.system2.id === 'vcc') {
                    this.dialogRef.close(true);
                }
                this.trackWithAnalyticTheTransaction();
                this.transactionFormService.transactionUpdatedSource.next({
                    email: this.transaction_form.controls.email.value,
                    title: 'saved',
                    id: response.data.attributes.transaction_temporal_values_id
                });
                this.transaction.is_saving = false;
                this.transaction.relationships.metas.data = [];
                this.callMetaTransactionsHelper();
                this.metaTransactionsHelper.addMetasToTransaction();
                this.urlUpdateService.updateUrlWithSuccesFullTransaction(this.router.url);
                this.changeDetectorRef.detectChanges();
            },
            (error): void => {
                this.transaction.is_saving = false;
                if (error.errors[0].code && error.errors[0].code.includes('rate_dropped')) {
                    this.messageAlertQuotationHelper.openDialog('La cotización de este pedido ha cambiado.');

                    return;
                }
                this.error.handleError(error);
                this.changeDetectorRef.detectChanges();
            }
        );
    }

    private trackWithAnalyticTheTransaction(): void {
        let average: number = this.generateAverage();
        let averageWithoutDecimals: number = Math.floor(average);
        this.analyticService.trackCustom('newTransaction', averageWithoutDecimals);
    }

    private generateAverage(): number {
        let amount1_usd: number = this.transaction.attributes.amount1 / (this.system1?.relationships.currency.data?.attributes.price ?? 1);
        let amount2_usd: number = this.transaction.attributes.amount2 / (this.system2?.relationships.currency.data?.attributes.price ?? 1);

        return (amount1_usd + amount2_usd) / 2;
    }

    private fillTransaction(): void {
        this.callMetaTransactionsHelper();
        this.transaction.is_saving = true;
        this.transaction.attributes.account_address1 = this.transaction_form.value.address1.trim() || '';
        this.transaction.attributes.account_address2 =
            this.system2?.id === 'pago_movil' || this.system2?.id === 'banco_bol'
                ? this.pagoMovilAdress
                : this.transaction_form.value.address2.trim() || '';
        this.transaction.attributes.name = this.transaction_form.value.name.trim();
        this.transaction.attributes.email = this.transaction_form.value.email;
        this.transaction.attributes.phone_number = this.transaction_form.value.whatsapp;
        this.transaction.attributes.account_network2 = this.selectedNetworkId;
        this.transaction.attributes.referral_id = this.referralsService.getReferralId() ?? null;
        this.transaction.attributes.source =
            (this.sourceService.getUtm('source_type') ?? '') + '-' + (this.sourceService.getUtm('utm_campaign') ?? '');
    }

    public setValidatorsAndErrors(control: AbstractControl, system: System): void {
        control.setValue('');
        control.setValidators(this.accountService.getValidatorAccount(system.attributes.account_type).accountValidate);
        control.updateValueAndValidity();
        control.setErrors(this.accountService.getValidatorAccount(system.attributes.account_type).accountValidate);
    }

    public specialsId(system2: System | null | undefined): boolean {
        if (system2 && system2.id) {
            let systemsId: Array<string> = ['banco_bol', 'pago_movil'];

            return systemsId.includes(system2.id);
        }

        return false;
    }

    public updatePagoMovilValue(pagoMovilAdress: string): void {
        this.pagoMovilAdress = pagoMovilAdress;
        if (this.system2 && this.system2.id) {
            this.checkAccountPagoMovil = checkSpecialAddressBySystem(pagoMovilAdress, this.system2.id);
        } else {
            this.checkAccountPagoMovil = false;
        }
    }

    private filterNetworks(address: string): void {
        if (this.system2) {
            if (address) {
                this.filteredNetworks = this.networkFilterHelper.disableNetworks(address, this.system2);

                const currentNetwork: any = this.filteredNetworks.find(
                    (filteredNetwork) => filteredNetwork.network.attributes.title === this.networkTitle
                );
                if (!currentNetwork || currentNetwork.disabled) {
                    const enabledNetwork: any = this.filteredNetworks.find((filteredNetwork) => !filteredNetwork.disabled);
                    if (enabledNetwork) {
                        this.networkTitle = enabledNetwork.network.attributes.title;
                        this.selectedNetworkId = enabledNetwork.network.id;
                    } else {
                        this.networkTitle;
                        this.selectedNetworkId = '';
                    }
                }
                this.isMatSelectDisabled = this.filteredNetworks.every((filteredNetwork) => filteredNetwork.disabled);
            } else {
                this.filteredNetworks = this.networkFilterHelper.disableNetworks('', this.system2);
                this.isMatSelectDisabled = this.filteredNetworks.length === 0;
            }
        } else {
            this.isMatSelectDisabled = true;
        }
        this.changeDetectorRef.detectChanges();
    }

    public networkSelect(address: string): void {
        if (address) {
            let networkId: BlockchainsEnum = this.networkFilterHelper.getNetworkByAddress(address, this.filteredNetworks);
            this.networkTitle =
                this.filteredNetworks.find((filteredNetwork) => filteredNetwork.network.id === networkId)?.network.attributes.title ?? '';
        } else {
            this.networkTitle = NetworkMessageHelper(this.system2);
        }
        this.networkSystemService.selectedNetworkTitle = this.networkTitle;
        if (this.networkTitle) {
            this.transaction_form.controls['account_network2'].setValue(this.networkTitle);
            this.onNetworkChange(this.networkTitle);
        }
    }

    public getNetworkIdByTitle(title: string): any {
        let network:
            | {
                  network: Network;
                  disabled: boolean;
              }
            | undefined = this.filteredNetworks.find((filteredNetwork) => filteredNetwork.network.attributes.title === title);

        return network ? network.network.id : null;
    }

    public onNetworkChange(networkTitle: string): void {
        this.networkTitle = networkTitle;
        this.networkSystemService.selectedNetworkTitle = networkTitle;

        const selectedNetwork: any = this.filteredNetworks.find(
            (filteredNetwork) => filteredNetwork.network.attributes.title === networkTitle
        );
        if (!selectedNetwork) {
            return;
        }

        this.selectedNetworkId = selectedNetwork.network.id;
        this.networkHelper.setTransaction(this.transaction).calculateAmount2ByNetwork(this.selectedNetworkId);
    }
}
